/* @refresh reload */
import css from "@/index.scss?inline";
import { withCSS } from "@/tools/with-css";
import { compose, register } from "component-register";
import { withSolid } from "solid-element";
import Main, { FeaturedDealerMFEProps } from "@/Main";
import { FeatureToggle } from "@/shared/enums/feature-toggle.enums";

// Web component tag name
export const FEATURED_DEALER_MFE = "featureddealer-mfe-wc";

// Default props for the web component
export const defaultProps: FeaturedDealerMFEProps = {
  dealerId: "49778",
  userId: "12345",
  userIsAdmin: true,
  featureToggles: {
    [FeatureToggle.FEATURED_DEALER_3_MONTHS]: true,
    [FeatureToggle.FEATURED_DEALER_6_MONTHS]: false,
  },
  cancelCampaign: undefined,
  permissions: {},
};

/**
 * Registers the Featured Dealer MFE as a custom element (web component).
 * Should only be called once
 */
export function registerWebComponent() {
  compose(
    register(FEATURED_DEALER_MFE, defaultProps),
    withCSS(css),
    withSolid,
  )(Main);
}
